import type { ReactNode } from 'react'
import { AuthProvider, UIProvider } from './AppContext'

// Re-export hooks for backward compatibility
export {
  useAuth,
  useCollapseMenu,
  useIsLogin,
  useListTab,
  useRouterContext,
  useSoundNotif,
  useTheme,
  useUI,
} from './AppContext'

/**
 * ProvidersContext - Heavily Optimized
 *
 * Merged 6 providers into 2:
 * 1. AuthProvider: User state + Permissions + Auth Status
 * 2. UIProvider: Theme + Router History + Collapse Menu + Tabs
 */
export function ProvidersContext({
  children,
}: {
  readonly children: ReactNode
}) {
  return (
    <AuthProvider>
      <UIProvider>{children}</UIProvider>
    </AuthProvider>
  )
}
